// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rpnHMotRr14TYJ4r0GQP{display:flex;flex-direction:column;gap:15px}.JfxB0QSNwjCTiGlX1x3Q{padding:16px 0}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/integrations/pages/integrationSettings/IntegrationKeapSettings/ui/IntegrationKeapSettingsSync/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,QAAA,CAEF,sBACE,cAAA","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n.titledRow {\n  padding: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `rpnHMotRr14TYJ4r0GQP`,
	"titledRow": `JfxB0QSNwjCTiGlX1x3Q`
};
export default ___CSS_LOADER_EXPORT___;
